var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../utils/index"], function (require, exports, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.togglePasswordVisibility = void 0;
    index_1 = __importDefault(index_1);
    exports.togglePasswordVisibility = function () {
        var togglePassword = document.querySelectorAll(".togglePassword");
        var passwordInputs = document.querySelectorAll(".password");
        togglePassword === null || togglePassword === void 0 ? void 0 : togglePassword.forEach(function (element, key) {
            if (element.getAttribute("listener") === "true") {
                element.removeEventListener("click", function () { return changeInputTypeAndImage(passwordInputs[key], element); }, false);
                element.setAttribute("listener", "false");
            }
            element.addEventListener("click", function () {
                changeInputTypeAndImage(passwordInputs[key], element);
                element.setAttribute("listener", "true");
            });
        });
        var changeInputTypeAndImage = function (input, image) {
            if (input.getAttribute("type") === "password") {
                input.setAttribute("type", "text");
                image.src = index_1.default.getBaseUrl() + "static/icons/eye.png";
            }
            else {
                input.setAttribute("type", "password");
                image.src = index_1.default.getBaseUrl() + "static/icons/eye-slash.png";
            }
        };
    };
});
